import {
  FlightLogsEvent,
  PointOfInterest,
  EventType,
  EventSubtype
} from '../../common/api/spidertracks-sdk/types/FlightLogs';

const FIFTEEN_MINUTES = 15 * 60 * 1000;
export const getEventKeyFromEvent = (event: FlightLogsEvent): string => {
  return `${event.eventType}-${event.eventSubtype}`;
};

export const getFormattedEventName = (
  event: FlightLogsEvent,
  pointOfInterest?: PointOfInterest
): string => {
  let code: string | undefined;
  // This should reflect the user preference
  if (pointOfInterest) {
    if ('code' in pointOfInterest) {
      code = pointOfInterest.code;
    } else if ('ICAO' in pointOfInterest) {
      code = pointOfInterest.ICAO;
    }
  }
  switch (event.eventType.toUpperCase()) {
    case EventType.POWER:
      switch (event.eventSubtype) {
        case EventSubtype.On:
          return 'Power On';
        case EventSubtype.Off:
          return 'Power Off';
        default:
          throw new Error(`Unknown event subtype: ${event.eventSubtype}`);
      }
    case EventType.ENGINE:
      switch (event.eventSubtype) {
        case EventSubtype.On:
          return 'Engine On';
        case EventSubtype.Off:
          return 'Engine Off';
        default:
          throw new Error(`Unknown event subtype: ${event.eventSubtype}`);
      }

    case EventType.FLIGHT:
      switch (event.eventSubtype) {
        case EventSubtype.Takeoff:
          return code ? `Departed ${code}` : 'Takeoff';
        case EventSubtype.Landing:
          return code ? `Arrived ${code}` : 'Landing';
        case EventSubtype.BlocksOff:
          return 'Blocks Off';
        case EventSubtype.BlocksOn:
          return 'Blocks On';
        default:
          throw new Error(`Unknown event subtype: ${event.eventSubtype}`);
      }
    default:
      throw new Error(`Unknown event type: ${event.eventType}`);
  }
};
export const getEventDescription = (event: FlightLogsEvent) => {
  switch (event.eventType) {
    case EventType.FLIGHT:
      switch (event.eventSubtype) {
        case EventSubtype.BlocksOn:
        case EventSubtype.BlocksOff:
          return 'Blocks Time';
        case EventSubtype.Landing:
        case EventSubtype.Takeoff:
          return 'Air Time';
        default:
          throw new Error(`Unknown event subtype: ${event.eventSubtype}`);
      }
    case EventType.ENGINE:
      switch (event.eventSubtype) {
        case EventSubtype.On:
        case EventSubtype.Off:
          return 'Engine Time';
        default:
          throw new Error(`Unknown event subtype: ${event.eventSubtype}`);
      }
    case EventType.POWER:
      switch (event.eventSubtype) {
        case EventSubtype.On:
        case EventSubtype.Off:
          return 'Spider Time';
        default:
          throw new Error(`Unknown event subtype: ${event.eventSubtype}`);
      }
    default: {
      const eventType = (event as FlightLogsEvent).eventType;
      throw new Error(`Unknown event type: ${eventType}`);
    }
  }
};

export function isFlightActive(latestPointTime: number): boolean {
  if (Date.now() - latestPointTime >= FIFTEEN_MINUTES) {
    return false;
  }
  return true;
}

export const getSerialBootCountKey = (serialNumber: string, bootCount: number) => {
  return `${serialNumber.toUpperCase()}-${bootCount}`;
};
